import { escapeRegExp } from '../escapeRegExp';

/**
 * Regex pattern of allowed charactes
 *
 * Example:
 * put `0-9` to allow only numbers
 */
export type AllowedCharactersPattern = string;

/**
 * Remove not allowed chars from string. Intended usage for form inputs (number, ip address etc.)
 */
export const makeWithAllowedCharacters = (
  pattern: AllowedCharactersPattern,
): ((value: string) => string) => {
  const regexp = new RegExp(`[^${escapeRegExp(pattern)}]`, 'g');

  return (value: string): string => value.replace(regexp, '');
};
